import axios from "axios";
import { useState, useCallback } from "react";
import { format } from "date-fns";
import { useAlert } from "./useAlert";

const API_URL = process.env.REACT_APP_API_URL;

export function useTodos() {
    const [todos, setTodos] = useState([]);
    const [allTodos, setAllTodos] = useState([]);
    const [customerTodos, setCustomerTodos] = useState([]);
    const { showAlert } = useAlert();

    const fetchTodos = useCallback(async (id) => {
        try {
            const res = await axios({
                method: "GET",
                url: `${API_URL}/todos/customer/${id}`,
                withCredentials: true
            });
            
            const allTodos = res.data.todos || [];

            const enrichedTodos = allTodos.map(todo => ({
                ...todo,
                customerName: todo.customer.prename + " " + todo.customer.name,
            }));

            // const now = new Date();
            // const futureTodos = enrichedTodos.filter(todo => 
            //     isAfter(new Date(todo.date), now)
            // );

            const sortedTodos = enrichedTodos.sort((a, b) => new Date(a.date) - new Date(b.date));

            const formattedTodos = sortedTodos.map((todo) => ({
                formattedDate: format(new Date(todo.date), "dd.MM.yyyy HH:mm"),
                description: todo.description,
                customerName: todo.customerName,
                createdAt: format(new Date(todo.createdAt), "dd.MM.yyyy HH:mm"),
                _id: todo._id,
                done: todo.done
            }));
            
            setTodos(formattedTodos);
        } catch (error) {
            showAlert('Fehler beim Laden der Todos', 'error');
        }
    }, [showAlert]);

    const fetchAllTodos = async () => {
        try {
            const res = await axios({
                method: "GET",
                url: `${API_URL}/todos`,
                withCredentials: true
            });
            
            const allTodos = res.data.todos || [];

            const enrichedTodos = allTodos.map(todo => ({
                ...todo,
                customerName: todo.customer.prename + " " + todo.customer.name,
            }));

            const sortedTodos = enrichedTodos.sort((a, b) => new Date(a.date) - new Date(b.date));

            const formattedTodos = sortedTodos.map((todo) => ({
                formattedDate: format(new Date(todo.date), "dd.MM.yyyy HH:mm"),
                description: todo.description,
                customerName: todo.customerName,
                _id: todo._id,
                done: todo.done,
                prio: todo.prio
            }));
            
            setAllTodos(formattedTodos);
        } catch (error) {
            showAlert('Fehler beim Laden der Todos', 'error');
        }
    }

    const deleteTodo = async (id) => {
        const confirmDelete = window.confirm(
            'Möchten Sie das Todo wirklich löschen?'
        );
        if (!confirmDelete) return;
    
        try {
            await axios.delete(`${API_URL}/todos/${id}`, {
                withCredentials: true
            });
    
            setTodos(prev => prev.filter(todo => todo._id !== id));
            setTimeout(() => window.location.reload(), 1000);
            showAlert('Todo erfolgreich gelöscht', 'success');
        } catch (err) {
            showAlert('Fehler beim Löschen des Todos', 'error');
            console.log(err)
        }
    };

    const updateTodo = async (id, updatedData) => {
        try {
            const response = await axios.patch(`${API_URL}/todos/${id}`, updatedData, {
                withCredentials: true
            });
            const updatedTodo = response.data.data.todo;

            setTodos((prevTodos) =>
                prevTodos.map((todo) =>
                    todo._id === id ? { ...todo, done: updatedTodo.done } : todo
                )
            );
            setAllTodos((prevTodos) =>
                prevTodos.map((todo) =>
                    todo._id === id ? { ...todo, done: updatedTodo.done } : todo
                )
            );
            showAlert('Todo erfolgreich aktualisiert.', 'success');
        } catch (error) {
            showAlert('Fehler beim Aktualisieren des Todos', 'error');
        }
    };

    const fetchCustomerTodos = async (id) => {
        try {
            const todoData = await axios.get(`${API_URL}/todos/customer/${id}`, { withCredentials: true });
            setCustomerTodos(todoData.data.data);
        } catch (error) {                
            showAlert("Fehler beim Laden der Tododetails", "error");
        }
    }

    const createTodo = async (startDate, description, id, prio) => {
        if(!startDate || !description) return showAlert('Bitte alle Felder eintragen.', 'error');
        try {
            const res = await axios({
                method: 'POST',
                url: `${API_URL}/todos/customer/${id}`,
                withCredentials: true,
                data: {
                    date: startDate,
                    description,
                    prio: Number(prio)
                }
            });
            if (res.data.status === 'success') {
                showAlert('Todo erfolgreich erstellt', 'success');
            
                setTimeout(() => window.location.reload(), 1000);
            } else {
                showAlert('Fehler beim Erstellen des Todos', 'error');
            }
        } catch (error) {
            showAlert('Fehler beim Erstellen des Todos', 'error');
            console.log(error)
        }
    };

    return { fetchTodos, fetchAllTodos, todos, allTodos, deleteTodo, updateTodo, fetchCustomerTodos, customerTodos, createTodo  }
}